import { useRequest } from '@fuxi/eevee-hooks';
import { SubPackageSlugEnum } from '@yaotai/common-utils';
import { CommonAPI } from '../services';

export enum ClientTypeEnum {
  Android = 'android',
  Ios = 'ios',
  Web = 'web', // 网页云游戏进入
  Wechat = 'wechat', // 微信云游戏进入
  Win = 'win',
}

export const CORPORATE_DEFAULT_PATH = 'corporate';

export const getCorporateUrl = ({ sid, portalUrl }: { portalUrl?: string; sid?: string } = {}) => {
  return `${portalUrl ? portalUrl : ''}/${SubPackageSlugEnum.Corporate}${
    sid ? `/${sid}` : `/${CORPORATE_DEFAULT_PATH}`
  }`;
};

export function useCommonUrls() {
  const { data, loading } = useRequest(CommonAPI.current!?.download.getDownloadUrls);

  const { android_url, ios_url, cloud_game_url, client_url, demo_aid, portal_url } = data?.data || {};

  return {
    androidUrl: android_url,
    iosUrl: ios_url,
    portalUrl: portal_url,
    cloudGameUrl: cloud_game_url,
    clientUrl: client_url,
    demoAid: demo_aid,
    demoUrl: `/${SubPackageSlugEnum.Center}/activity/${demo_aid}`,
    clientDownloadUrlMap: {
      [ClientTypeEnum.Win]: client_url,
      [ClientTypeEnum.Android]: android_url,
      [ClientTypeEnum.Ios]: ios_url,
    },
    isGettingCommonUrls: loading,
  };
}
